import { render } from "./sales-rep-dashboard-sections.vue?vue&type=template&id=36a2b27a&scoped=true"
import script from "./sales-rep-dashboard-sections.vue?vue&type=script&lang=js"
export * from "./sales-rep-dashboard-sections.vue?vue&type=script&lang=js"

import "./sales-rep-dashboard-sections.vue?vue&type=style&index=0&id=36a2b27a&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-36a2b27a"]])

export default __exports__